import React, { useEffect, useState } from 'react'
import { Tooltip } from 'bootstrap';
import Image from './Image';

const ProgramCard = ({image, title, date}) => {
    useEffect(() => {
        // Activer tous les tooltips dans le composant
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        tooltipTriggerList.forEach((tooltipTriggerEl) => {
            new Tooltip(tooltipTriggerEl);
        });
    }, []);


    const [customStyle, setCustomStyle] = useState({
        width: window.innerWidth < 576 ? 'calc(100% - 52px - .25rem)' : '100%',
        height: window.innerWidth < 576 ? '98%' : '563px',
    });

    useEffect(() => {
        const handleResize = () => {
            setCustomStyle(prev => ({
                ...prev,
                width: window.innerWidth < 576 ? 'calc(100% - 52px - .25rem)' : '100%',
                height: window.innerWidth < 576 ? '98%' : '563px',
            }));
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    return (
        <div className='d-flex flex-sm-column flex-row-reverse justify-content-end' role='button' data-bs-toggle="tooltip" data-bs-placement="top" data-bs-custom-class="program-tooltip" data-bs-title={title}>
            
            {/* Image */}
            <div className=' position-relative mb-sm-0 mb-3 pe-sm-3' style={customStyle}>
                <Image alt={title} src={image} className={'object-fit-contain w-100 h-100'} />
                <div className='position-absolute top-0 start-0 w-100 h-100'>
                    <div className='bgcolor-program-card w-100 h-100 d-flex justify-content-center align-items-end'>
                        <div className='px-1 text-center'>
                            <p className='fs-9s fw-bold text-truncate-1 mb-1 text-white'>{title}</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Heure */}
            <div className='row flex-sm-row flex-column justify-content-between align-items-center gx-0 py-sm-1 me-sm-0 me-1'>
                <p className='col-auto fs-8s fw-bold mb-0 bgcolor-primary text-nowrap text-white' style={{padding:'0.1rem 0.5rem'}}>
                    {date}
                </p>
                <div className='col-sm col bgcolor-primary' style={{width:'2px', paddingTop:'2px'}}></div>
            </div>
        </div>
    )
}

export default ProgramCard